import { render } from "./LeftIcon.vue?vue&type=template&id=3f07161e"
import script from "./LeftIcon.vue?vue&type=script&lang=js"
export * from "./LeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__